import { ICreateUserReplyTemplateRequestSchema } from '../repositories/chats/entities/reply_templates/CreateUserReplyTemplateRequestSchema';
import { ICreateUserReplyTemplatesListResponseSchema } from '../repositories/chats/entities/reply_templates/CreateUserReplyTemplatesListResponseSchema';
import { IDeleteUserReplyTemplateRequestSchema } from '../repositories/chats/entities/reply_templates/DeleteUserReplyTemplateRequestSchema';
import { IRecoverUserReplyTemplateRequestSchema } from '../repositories/chats/entities/reply_templates/RecoverUserReplyTemplateRequestSchema';
import { IReplyTemplateSchema } from '../repositories/chats/entities/reply_templates/ReplyTemplateSchema';
import { IUpdateUserReplyTemplateRequestSchema } from '../repositories/chats/entities/reply_templates/UpdateUserReplyTemplateRequestSchema';
import { IUpdateUserReplyTemplateResponseSchema } from '../repositories/chats/entities/reply_templates/UpdateUserReplyTemplateResponseSchema';
import { IUserReplyTemplatesListResponseSchema } from '../repositories/chats/entities/reply_templates/UserReplyTemplatesListResponseSchema';

import type { ERequestApiStatus } from './appState';

export enum EReplyTemplateModalStep {
  List = 'list',
  Create = 'create',
  Edit = 'edit',
  Error = 'error',
}

export type TReplyTemplatesState = {
  data: {
    status: ERequestApiStatus;
    limit: number;
    replyTemplates: IReplyTemplateSchema[];
    errorMessage: string | undefined;
  };
  editableReplyTemplateId: number | null;
  isNewEnabled: boolean;
  isEnabled: boolean;
  isInputButtonVisible: boolean;
  isOnboardingEnabled: boolean;
  isModalOpen: boolean;
  modalStep: EReplyTemplateModalStep | null;
  initialText: string | null;
};

export type {
  IUserReplyTemplatesListResponseSchema as IUserReplyTemplatesListResponse,
  ICreateUserReplyTemplatesListResponseSchema as ICreateUserReplyTemplatesListResponse,
  IUpdateUserReplyTemplateResponseSchema as IUpdateUserReplyTemplateResponse,
  ICreateUserReplyTemplateRequestSchema as ICreateUserReplyTemplateRequest,
  IUpdateUserReplyTemplateRequestSchema as IUpdateUserReplyTemplateRequest,
  IRecoverUserReplyTemplateRequestSchema as IRecoverUserReplyTemplateRequest,
  IDeleteUserReplyTemplateRequestSchema as IDeleteUserReplyTemplateRequest,
  IReplyTemplateSchema as IReplyTemplate,
};
